import useSWR from 'swr'
import { getReq } from '../service/API'
import { ENDPOINTS } from '../service/ENDPOINTS'

export const useQuestionnaire = (projectId: string, questionnaireId: string) => {
  const p = questionnaireId ? ENDPOINTS.QUESTIONNAIRES.byQuestionnaireId(projectId, questionnaireId) : ''
  const { data, mutate, error } = useSWR(p, getReq, { suspense: true })

  return {
    data: !data ? null : data.data,
    isLoading: !error && !data,
    isError: error,
    mutate: mutate,
  }
}
